export const JSON_ONE11 = {
   
  

    "re_id": "010220170001",
    "me_id": "<Encrypted Merchant ID(meId)>"


    }



